import { render, staticRenderFns } from "./DetailsTab.vue?vue&type=template&id=c0027012&scoped=true"
import script from "./DetailsTab.component.js?vue&type=script&lang=js&external"
export * from "./DetailsTab.component.js?vue&type=script&lang=js&external"
import style0 from "./DetailsTab.vue?vue&type=style&index=0&id=c0027012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0027012",
  null
  
)

export default component.exports